// components/TeamConsumptionTimeline.tsx
'use client';

import React from 'react';
import ConsumptionTimeline from './ui/ConsumptionTimeline';

interface TeamConsumptionTimelineProps {
  teamId: string;
  teamName: string;
}

const TeamConsumptionTimeline: React.FC<TeamConsumptionTimelineProps> = ({
  teamId,
  teamName,
}) => (
  <ConsumptionTimeline
    endpoint={`/api/inventory/teams/${teamId}/consumption`}
    scopeName={teamName}
    csvPrefix="fater_team_consumption_"
    emptyLabel="No credit activity yet."
    fetchErrorLabel="Failed to fetch team consumption analytics:"
  />
);

export default React.memo(TeamConsumptionTimeline);
